import { useContext } from "react";
import { ToastContext } from "context/ToastContext";

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) throw Error("useToast must be used within a ToastProvider");
  return context;
};
